const firebaseConfig = {
  apiKey: "AIzaSyBnb7NoxYVU7HiIEwOxJ8ANDuCI1BewBK8",
  authDomain: "dot-baba.firebaseapp.com",
  projectId: "dot-baba",
  storageBucket: "dot-baba.appspot.com",
  messagingSenderId: "730985157980",
  appId: "1:730985157980:web:b92b20894093b9795f5d99",
};

export default firebaseConfig;
